import axios from "axios";
import D3Funnel from 'd3-funnel'
export default function (chart, divId, vizName, filterParam, checkbox) {
    // axios({ url: '/json/funneldata.json', baseURL: '', method: 'GET' }).then(res => {
    // let data = res.data

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    axios.post(url, filterParam).then(res => {

        let data0 = res.data;

        //  console.log(data)
        // console.log("data",data0,chart)
        // console.log(vizName)
        // console.log(filterParam)

        const container = [];

        // for (let i = 0; i < labels.length; i++) {
        //     container[i] = {
        //         label: labels[i].name,
        //         value: values[i].formattedValue
        //     };
        // }

        console.log(container);


        const chart = new D3Funnel(divId)

        /*
        data0 = [
            { label: 'Hired', value: 1500 },
            { label: 'Interviewed', value: 2500 },
            { label: 'Pre-screened', value: 4000 },
            { label: 'Applicants', value: 12000 },
            { label: 'Overflow', value: 1200 },
            { label: 'Called', value: 7000 },
        ];
*/

        // var metric1ColorScale =d3.scaleSequential()
        //     .interpolator(d3['interpolate' + 'YlGn'])
        //      .domain([d3.min(data0,function(d){ return d.value}),d3.max(data0,function(d){ return d.value})])

        //   var fw_progressive_4way=d3.interpolateViridis;

        let dynamicHeightcheckbox = checkbox == true ? true : false

        const options = {
            chart: {
                width: 300,
                height: 500,
                //  bottomWidth: 1 / 3,
                bottomPinch: 1,
                inverted: false,
                curve: {
                    enabled: false,
                    height: 20,
                    shade: -0.4
                },
                totalCount: null,
            },
            block: {
                dynamicHeight: dynamicHeightcheckbox,
                dynamicSlope: false,
                barOverlay: false,
                fill: {
                    type: "gradient",
                    scale: ['#002B5B', '#1A5F7A', '#57C5B6', '#159895', '#145755', '#157855']
                },
                minHeight: 25,
                highlight: false
            },
            label: {
                enabled: true,
                fontFamily: null,
                fontSize: "12px",
                fill: "#fff",
                format: `{v} \n {l}`,
            },
            tooltip: {
                enabled: false,
                format: "{l} : {f}"
            },
            // events: {
            //     click: {
            //         block: null
            //     }
            // }
        };

        chart.draw(data0, options);

    })
}
